import { z } from "zod";

export const phoneSchema = z.object({
  phone: z
    .string()
    .refine(
      (value) => {
        const digits = value.replace(/\D/g, "");
        return digits.length >= 10;
      },
      { message: "Phone number must be at least 10 digits." },
    )
    .refine(
      (value) => {
        const digits = value.replace(/\D/g, "");
        return digits.length <= 15;
      },
      { message: "Phone number cannot exceed 15 digits." },
    ),
  privacyPolicy: z.boolean().refine((val) => val === true, {
    message: "You must agree to the privacy policy",
  }),
});
